import React from "react";

interface PipOverlayLabelProps {
  readonly message?: string;
  readonly className?: string;
}

export function PipOverlayLabel({
  message = "Video Is Playing In Picture In Picture",
  className = "",
}: Readonly<PipOverlayLabelProps>) {
  return (
    <div
      className={`absolute inset-0 z-[3] flex items-center justify-center bg-black/30 text-center backdrop-blur-md ${className}`}
      style={{
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <span className="font-rubik px-4 text-[12px] leading-[1.4] font-medium tracking-[0.02em] text-white md:text-[14px]">
        {message}
      </span>
    </div>
  );
}
